import {
    ADD_USER_EXCEPTION_FAILURE,
    ADD_USER_EXCEPTION_REQUEST,
    ADD_USER_EXCEPTION_SUCCESS, UPDATE_MSG_ADD, DELETE_USER_EXCEPTION_FAILURE,
    DELETE_USER_EXCEPTION_REQUEST,
    DELETE_USER_EXCEPTION_SUCCESS,
    FETCH_USER_EXCEPTION_FAILURE,
    FETCH_USER_EXCEPTION_REQUEST,
    FETCH_USER_EXCEPTION_SUCCESS,
} from '../../actions/admin/userException.action';
import { sortArray } from '../../utils/common';

const formatDate = (date) => date.toString().replace(/GMT.*/g, '');


const initialState = {
    data: [],
    loading: false,
    error: '',
    updatedDateTime: formatDate(new Date()),
    newItemError: null,
    deleteItemError: null,
};


const userExceptionReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_USER_EXCEPTION_REQUEST:
            return { ...state, loading: true, error: null };
        case FETCH_USER_EXCEPTION_SUCCESS:
            return {
                ...state,
                updatedDateTime: formatDate(new Date()),
                loading: false,
                data: sortArray(action.payload, 'email'),
            };
        case FETCH_USER_EXCEPTION_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case ADD_USER_EXCEPTION_REQUEST:
            return { ...state, loading: true, error: null };
        case ADD_USER_EXCEPTION_SUCCESS:
            const data_add = action.payload?.id ? [...state.data, { ...action.payload }] : [...state.data];
            return {
                ...state,
                updatedDateTime: formatDate(new Date()),
                loading: false,
                data: sortArray(data_add, 'email'),
            };
        case ADD_USER_EXCEPTION_FAILURE:
            return { ...state, loading: false, newItemError: action.payload };

        case DELETE_USER_EXCEPTION_REQUEST:
            return { ...state, loading: true, error: null };
        case DELETE_USER_EXCEPTION_SUCCESS:
            const data_delete = action.payload ? [...state.data.filter(f => f.id !== action.payload)] : [...state.data];
            return {
                ...state,
                updatedDateTime: formatDate(new Date()),
                loading: false,
                data: sortArray(data_delete, 'email'),
            };
        case DELETE_USER_EXCEPTION_FAILURE:
            return { ...state, loading: false, deleteItemError: action.payload };
        case UPDATE_MSG_ADD:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export default userExceptionReducer;